import type { Weapon } from './Weapon';
import { createRevolver } from './Revolver';

const MAX_SLOTS = 10;

export class Inventory {
  private slots: (Weapon | null)[];
  private currentSlot: number;

  constructor() {
    this.slots = new Array(MAX_SLOTS).fill(null);
    this.currentSlot = 0;
    this.slots[0] = createRevolver();
  }

  getCurrentWeapon(): Weapon {
    const weapon = this.slots[this.currentSlot];
    if (!weapon) {
      const firstAvailable = this.slots.findIndex((w) => w !== null);
      if (firstAvailable === -1) {
        throw new Error('Inventory empty - this should not happen');
      }
      this.currentSlot = firstAvailable;
      return this.slots[firstAvailable]!;
    }
    return weapon;
  }

  getWeaponAtSlot(slot: number): Weapon | null {
    if (slot < 0 || slot >= MAX_SLOTS) return null;
    return this.slots[slot];
  }

  getCurrentSlot(): number {
    return this.currentSlot;
  }

  // Возвращает true если добавлено. Занятый слот не перезаписывается.
  addWeaponAtSlot(weapon: Weapon, slot: number): boolean {
    if (slot < 0 || slot >= MAX_SLOTS) return false;
    if (this.slots[slot] !== null) return false;
    this.slots[slot] = weapon;
    return true;
  }

  // Возвращает true если переключение произошло.
  switchToSlot(slot: number): boolean {
    if (slot < 0 || slot >= MAX_SLOTS) return false;
    if (this.slots[slot] === null) return false;
    if (this.currentSlot === slot) return false;

    // Раскрутка теряется при смене оружия (логически = "отпустил спуск").
    const previous = this.slots[this.currentSlot];
    if (previous) previous.releaseFire();

    this.currentSlot = slot;
    return true;
  }

  isSlotOccupied(slot: number): boolean {
    return slot >= 0 && slot < MAX_SLOTS && this.slots[slot] !== null;
  }

  getOccupiedSlots(): number[] {
    const result: number[] = [];
    for (let i = 0; i < MAX_SLOTS; i++) {
      if (this.slots[i] !== null) result.push(i);
    }
    return result;
  }
}
